import { render } from "./TeamField.vue?vue&type=template&id=c33c2ed6&scoped=true"
import script from "./TeamField.vue?vue&type=script&lang=js"
export * from "./TeamField.vue?vue&type=script&lang=js"

import "./TeamField.vue?vue&type=style&index=0&id=c33c2ed6&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33c2ed6"]])

export default __exports__